/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import gql from "graphql-tag";

export const GET_SECTION_OPTIONS = gql`
  query GetCostumeTypes(
    $filter: CostumeTypeFilterInput
    $options: GetManyOptions
  ) {
    getCostumeTypes(filter: $filter, options: $options) {
      count
      limit
      skip
      content {
        name
        sectionSpecificInvites
        specialInvites
        id
        defaultInvites
        section {
          name
        }
        inventoryDetail {
          defaultInvitesRemaining
          defaultInvitesUsed
          sectionSpecificInvitesRemaining
          sectionSpecificInvitesUsed
          specialInvitesRemaining
          specialInvitesUsed
        }
        updateHistory {
          _id
          date
          user {
            email
            fullName
          }
          description
        }
      }
    }
  }
`;
export const GET_ALL_SECTION_OPTIONS = gql`
  query GetCostumeTypes($filter: CostumeTypeFilterInput) {
    getCostumeTypes(filter: $filter) {
      count
      limit
      skip
      content {
        name
        sectionSpecificInvites
        specialInvites
        id
        defaultInvites
        section {
          name
        }
        inventoryDetail {
          defaultInvitesRemaining
          defaultInvitesUsed
          sectionSpecificInvitesRemaining
          sectionSpecificInvitesUsed
          specialInvitesRemaining
          specialInvitesUsed
        }
        updateHistory {
          _id
          date
          user {
            email
            fullName
          }
          description
        }
      }
    }
  }
`;

// updateHistory {
//   _id
//   date
//   user {
//     email
//     fullName
//   }
// }
